import MessageDate from 'app/features/conversations/Components/Message/MessageDate';
import useBoolean from 'app/hooks/useBoolean';
import { INote, useDeleteNoteMutation } from 'app/services/notes';
import DeleteButton from 'Components/Buttons/DeleteButton';
import { successToast } from 'Components/Notifications';
import { PaginationContext } from 'Components/Pagination/usePagination';
import UserBox from 'Components/UserBox';
import { useContext } from 'react';
import { useAuth } from 'utils/AuthProvider';

export default function NoteCard({
  value: note,
  label = 'Note',
}: {
  value: INote;
  label?: string;
}) {
  const { userId } = useAuth();

  const [deleteNote] = useDeleteNoteMutation();
  const { toggle: toggleConfirmDelete, value: confirmDelete } = useBoolean();

  const { refetchAfterDelete } = useContext(PaginationContext);
  return (
    <UserBox
      theme={note.user.id === userId ? 'green' : 'gray'}
      key={note.id}
      user={note.user}
      content={
        <div className="mt-2 text-gray-700 break-words whitespace-pre-line">
          {note.body}
        </div>
      }
      size="sm"
      px="6"
      py="4"
      my=""
      right={
        <div className="flex flex-col items-end">
          <MessageDate
            value={note.created_at}
            className="text-sm mb-2 text-gray-700"
          />

          {userId === note.user.id &&
            (confirmDelete ? (
              <div className="flex gap-2 cursor-default h-8 items-center animate-enter transform">
                <div className="text-gray-dark  p-1">
                  Are you sure you want to delete ?
                </div>
                <button
                  className="text-red-dark cursor-pointer font-bold rounded hover:text-opacity-80 h-8 w-10 flex justify-center items-center"
                  onClick={async () => {
                    return deleteNote(note.id)
                      .unwrap()
                      .then(() => {
                        refetchAfterDelete();
                        successToast(`${label} deleted successfully`);
                      });
                  }}
                >
                  Yes
                </button>
                <button
                  className="cursor-pointer font-bold  text-gray-700 rounded hover:text-opacity-80 h-8 w-10 flex justify-center items-center"
                  onClick={toggleConfirmDelete}
                >
                  No
                </button>
              </div>
            ) : (
              <DeleteButton onClick={toggleConfirmDelete} />
            ))}
        </div>
      }
    ></UserBox>
  );
}
